// 企业报告预览 mock（/print/enterprise/preview）。5 力 / 四阶 / 无素质（spec §4.4）。
// 维度码与后端 Dimension.code 对齐：ai_leverage/ai_symbiosis/ai_team_leadership/ai_governance/ai_strategic_foresight

const DIMS = [
  { code: 'ai_leverage', name: 'AI 借力' },
  { code: 'ai_symbiosis', name: 'AI 共生' },
  { code: 'ai_team_leadership', name: 'AI 带队' },
  { code: 'ai_governance', name: 'AI 治理' },
  { code: 'ai_strategic_foresight', name: 'AI 谋势' },
];

const radar = (scores) =>
  DIMS.map((d, i) => ({ code: d.code, name: d.name, sort_order: i, avg_score: scores[i], affected_count: 0 }));

const layers = (c1, c2, c3, c4) => [
  { l_grade: 'L1', count: c1, pct: c1 },
  { l_grade: 'L2', count: c2, pct: c2 },
  { l_grade: 'L3', count: c3, pct: c3 },
  { l_grade: 'L4', count: c4, pct: c4 },
];

export const mockEnterpriseReportPayload = {
  scope: 'enterprise',
  cover: { enterprise_name: '光明智能集团', industry: '制造业', class_count: 3, headcount: 60, report_date: '2026-06-10' },
  overview: {
    enterprise: '光明智能集团',
    class_count: 3,
    total_unique_headcount: 60,
    completed_headcount: 52,
    company_layer_distribution: layers(10, 22, 18, 10),
    company_dimension_radar: radar([72, 65, 58, 80, 69]),
    company_position_top5: [
      { position: '研发工程师', count: 18 },
      { position: '产品经理', count: 12 },
      { position: '运营', count: 9 },
      { position: '销售', count: 7 },
      { position: '行政', count: 6 },
    ],
    classes_kpi_matrix: [
      { class_id: 1, class_name: '一班', size: 22, completion_rate: 90.9, team_avg: 78.5,
        layer_dist: layers(2, 8, 8, 4), short_dims: [{ code: 'ai_team_leadership', name: 'AI 带队', avg_score: 55 }], risk_count: 3 },
      { class_id: 2, class_name: '二班', size: 20, completion_rate: 85.0, team_avg: 66.2,
        layer_dist: layers(5, 9, 4, 2), short_dims: [{ code: 'ai_symbiosis', name: 'AI 共生', avg_score: 52 }], risk_count: 6 },
      { class_id: 3, class_name: '三班', size: 18, completion_rate: 77.8, team_avg: 71.0,
        layer_dist: layers(3, 5, 6, 4), short_dims: [], risk_count: 2 },
    ],
    cross_class_dimension_heatmap: [
      { class_id: 1, class_name: '一班', cells: radar([82, 70, 55, 88, 74]).map((d) => ({ code: d.code, name: d.name, score: d.avg_score })) },
      { class_id: 2, class_name: '二班', cells: radar([60, 52, 58, 72, 63]).map((d) => ({ code: d.code, name: d.name, score: d.avg_score })) },
      { class_id: 3, class_name: '三班', cells: radar([74, 68, 62, 80, 70]).map((d) => ({ code: d.code, name: d.name, score: d.avg_score })) },
    ],
    classes_overflow: null,
  },
  scheduling: {
    generated_at: '2026-06-10T08:00:00+08:00',
    ai_meta: { model: 'glm-4-plus', prompt_version: 6 },
    headline_tag: '研发主力强、协同短板待补',
    comprehensive_interpretation: '全员 AI 治理能力领先，AI 带队/共生为相对洼地，建议跨班合并补强协同类场景。',
    scheduling_recommendations: [
      { priority: 'P0', title: '跨班协同实战工作坊', target_classes: ['一班', '二班'], covered_dims: ['AI 带队', 'AI 共生'],
        merge_strategy: '二班并入一班标杆带练', rationale: '二班协同最弱、一班有标杆', improvement_directions: ['案例复盘', '结对实操'],
        resource_efficiency: '一次覆盖两班', predicted_coverage: '42 人' },
      { priority: 'P1', title: 'AI 谋势进阶', target_classes: ['三班'], covered_dims: ['AI 谋势'],
        merge_strategy: '独立开班', rationale: '三班谋势基础好可拔高', improvement_directions: ['战略沙盘'],
        resource_efficiency: '小班精授', predicted_coverage: '18 人' },
    ],
    quarterly_schedule: [
      { quarter: 'Q3', items: ['跨班协同工作坊', '基础巩固'] },
      { quarter: 'Q4', items: ['AI 谋势进阶', '成果评估'] },
    ],
    class_commentaries: [
      { class_id: 1, class_name: '一班', headcount: 22, team_avg: 78.5, commentary: '整体领先，可作为标杆班带动他班。' },
      { class_id: 2, class_name: '二班', headcount: 20, team_avg: 66.2, commentary: '协同短板明显，优先补强 AI 共生/带队。' },
      { class_id: 3, class_name: '三班', headcount: 18, team_avg: 71.0, commentary: '基础扎实，建议向谋势进阶。' },
    ],
  },
};

export const mockEnterpriseTeamPayload = {
  scope: 'enterprise_team',
  cover: { enterprise_name: '星海科技', industry: '互联网', class_count: 0, headcount: 30, report_date: '2026-06-10' },
  overview: {
    enterprise: '星海科技',
    total_unique_headcount: 30,
    completed_headcount: 26,
    company_layer_distribution: layers(5, 11, 8, 6),
    company_dimension_radar: radar([70, 63, 60, 75, 66]),
    company_position_top5: [
      { position: '工程师', count: 14 },
      { position: '设计师', count: 6 },
    ],
    score_distribution: [],
  },
  scheduling: {
    generated_at: '2026-06-10T08:00:00+08:00',
    ai_meta: { model: 'glm-4-plus', prompt_version: 6 },
    headline_tag: '全员均衡、谋势可拔高',
    comprehensive_interpretation: '团队整体 AI 治理稳健，建议统一推进谋势类训练。',
    scheduling_recommendations: [
      { priority: 'P1', title: '全员谋势训练', target_classes: [], covered_dims: ['AI 谋势'],
        merge_strategy: '全员统一', rationale: '谋势为相对洼地', improvement_directions: ['战略案例'],
        resource_efficiency: '统一开课', predicted_coverage: '30 人' },
    ],
    quarterly_schedule: [{ quarter: 'Q3', items: ['全员谋势训练'] }],
    class_commentaries: [],
  },
};
